exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog .modal-body {\n  padding: 15px 50px 50px; }\n\n.modal-dialog .modal-footer {\n  padding: 32px 50px;\n  text-align: left; }\n\n@media (min-width: 576px) and (max-width: 767px) {\n  .modal-dialog .modal-footer {\n    text-align: center; }\n    .modal-dialog .modal-footer h6 {\n      margin-bottom: 0;\n      font-size: 15px; }\n    .modal-dialog .modal-footer .border-b {\n      margin: 0 15px 5px;\n      border-bottom: 1px solid #d8dadc;\n      padding: 5px; } }\n\n@media (max-width: 575px) {\n  .modal-dialog .modal-body {\n    padding: 0 20px 35px; }\n  .modal-dialog .modal-footer {\n    padding: 20px;\n    text-align: center; }\n    .modal-dialog .modal-footer h6 {\n      margin-bottom: 0;\n      font-size: 15px; }\n    .modal-dialog .modal-footer .border-b {\n      margin: 0 20px 5px;\n      border-bottom: 1px solid #d8dadc;\n      padding: 5px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/shared/forgot-password/forgot-password.component.scss
// module id = ../../../../../src/app/shared/forgot-password/forgot-password.component.scss
// module chunks = main